import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { ButtonWithLoaderProps } from '@pbt/pbt-ui-components'

import type { PrescriptionActionContextType } from '~/components/common/PrescriptionContext'
import DialogNames from '~/constants/DialogNames'
import FeatureToggle from '~/constants/featureToggle'
import {
  PrescriptionDeclineReasonName,
  PrescriptionDeclineReasonType,
} from '~/constants/PrescriptionWorkflow'
import { getFeatureToggle } from '~/store/reducers/constants'
import useDialog from '~/utils/useDialog'

import { ButtonWithMenu } from './ButtonWithMenu'

export interface PrescriptionDeclineActionProps extends ButtonWithLoaderProps {
  onDecline: PrescriptionActionContextType['onDecline']
}

const PrescriptionDeclineAction = ({
  onDecline,
  ...props
}: PrescriptionDeclineActionProps) => {
  const { t } = useTranslation(['Common'])

  const isSwapReactiveRxEnabled = useSelector(
    getFeatureToggle(FeatureToggle.SWAP_REACTIVE_RX),
  )

  const [openDialog] = useDialog(DialogNames.PRESCRIPTION_DECLINE_REASON)
  const [openChirpDialog] = useDialog(
    DialogNames.PRESCRIPTION_DECLINE_REASON_CHIRP,
  )

  const handleDecline = (declineReason: PrescriptionDeclineReasonType) => {
    if (declineReason === PrescriptionDeclineReasonType.OTHER) {
      if (isSwapReactiveRxEnabled) {
        openChirpDialog({ onDecline })
      } else {
        openDialog({ onDecline })
      }
    } else {
      onDecline(PrescriptionDeclineReasonName[declineReason])
    }
  }

  return (
    <ButtonWithMenu
      buttonText={t('Common:DECLINE_ACTION')}
      name="prescription-decline"
      optionsDisplayMap={PrescriptionDeclineReasonName}
      optionsValueMap={PrescriptionDeclineReasonType}
      onSelectOption={handleDecline as (declineReason: string) => void}
      {...props}
    />
  )
}

export default PrescriptionDeclineAction
